module.exports = __webpack_public_path__ + "media/images/test_module_default-ee0f4dbe.jpg";